export default "__VITE_ASSET__CLGUxe9l__"